<div class="container">
  <div class="row mt-4">
    <div class="col">
      <h1>You have attempted to log in to a site which you are not authorized to access.</h1>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <p>
        Your credentials do not provide access to this site. Your login may be valid for another
        site. Please try to log out and log back in with valid credentials.
      </p>
      <p>
        <a class="mat-button-link" (click)="logout()">Log Out</a>
      </p>
    </div>
  </div>
</div>
